import React, { useCallback, useRef, useState } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, CardView, SCROLL_INDICATOR_INSETS, SettingsItemInput, StatusBar, withAnimatedNavigationHeader, } from 'design-system';
import { IconSmartRule } from 'design-system/icons';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import { useAutoFocusInput } from 'hooks/useAutoFocusInput';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { KeyboardAvoidingButton } from 'design-system/KeyboardAvoidingButton';
import SmartRuleNameSuggestions from '../components/SmartRuleNameSuggestions';
const strings = {
    title: 'Name your smart rule',
    subtitle: 'This will help you identify what the rule does',
};
const SmartRuleNameScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const nameRef = useRef(null);
    useAutoFocusInput(nameRef);
    const [name, setName] = useState('');
    const [suggestedData, setSuggestedData] = useState();
    const handleSuggestionPress = useCallback((name) => {
        setName(name);
        setSuggestedData({ name });
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} keyboardShouldPersistTaps="handled" contentContainerStyle={contentContainerStyle}>
          <ScreenInfoHeader title={strings.title} subTitle={strings.subtitle}/>
          <CardView noMarginBottom noMarginTop>
            <SettingsItemInput ref={nameRef} description="Name" icon={<IconSmartRule />} value={name} onChangeText={setName} placeholder="Enter name" iconSize={44} returnKeyType="done"/>
          </CardView>
          <SmartRuleNameSuggestions name={name} handleSuggestionPress={handleSuggestionPress} suggestedData={suggestedData}/>
        </Animated.ScrollView>
        <KeyboardAvoidingButton brand title="Continue" disabled={!name} onPress={() => navigation.navigateDeprecated('SmartRuleSelectAccount', { name })}/>
      </AppView>);
}, ({ colors }) => ({
    title: strings.title,
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default SmartRuleNameScreen;
